module.exports = __webpack_public_path__ + "static/img/YH.e201006.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YH.png
// module id = l/rC
// module chunks = 1